<template>

  <div class="container-fluid topbar">
    <div class="row">
      <div class="col-6 no-overflow">
        <img src="../assets/logo_white.svg" class="logo">
        &nbsp;
        {{stopName}}
        </div>
        <div class="col-3 time"><i class="far fa-clock"></i>&nbsp;{{getTime()}}
          </div>
          <div class="col menu">

        <i class="fas fa-spinner" v-if="updateInProgress"></i>
            <i class="far fa-hourglass"></i> {{timeSinceLastUpdate}}
            </div> <div class="col-1 menu" v-if="!kiosk">
        <router-link to="/page/einstellungen"><i class="fas fa-sign-out-alt"></i></router-link>
        </div>
      </div>

    </div>
</template>

<script>
export default {
  name: 'NavbarElement',
  components: {
  },
  props: {
    stopName: String,
    timeSinceLastUpdate: String,
    updateInProgress: Boolean,
    kiosk: Boolean
  },
  methods: {
    getTime: () => {
      return new Date().getHours() + ':' + (new Date().getMinutes() < 10 ? '0' : '') + new Date().getMinutes()
    }
  }
}
</script>

<style scoped>
.container{
  max-width: 1000rem;
}
.topbar {
  color: #ffffff;
  font-size: 3rem;
  font-weight: 600;
  background-color: #000000;
}
.menu{
  text-align: right;
}

.menu a {
  color: #ffffff;
}
.logo {
  height: 60px;
}
.no-overflow {
  overflow: hidden;
  white-space: nowrap;
}
</style>
